var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailthumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_497_561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 26,
    height: 26,
    fill: "#AEAAAB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_497_561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail",
    d: "M4.33329 21.6673C3.73746 21.6673 3.22739 21.4552 2.80308 21.0309C2.37878 20.6066 2.16663 20.0965 2.16663 19.5007V6.50065C2.16663 5.90482 2.37878 5.39475 2.80308 4.97044C3.22739 4.54614 3.73746 4.33398 4.33329 4.33398H21.6666C22.2625 4.33398 22.7725 4.54614 23.1968 4.97044C23.6211 5.39475 23.8333 5.90482 23.8333 6.50065V19.5007C23.8333 20.0965 23.6211 20.6066 23.1968 21.0309C22.7725 21.4552 22.2625 21.6673 21.6666 21.6673H4.33329ZM13 14.084L4.33329 8.66732V19.5007H21.6666V8.66732L13 14.084ZM13 11.9173L21.6666 6.50065H4.33329L13 11.9173ZM4.33329 8.66732V6.50065V19.5007V8.66732Z",
    fill: "#AEAAAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailthumb);
export default __webpack_public_path__ + "static/media/mailthumb.a58485c2831ac2d71ed79e9ed5102905.svg";
export { ForwardRef as ReactComponent };